import { TextFieldProps } from '@material-ui/core';
import { useController, UseControllerProps } from 'react-hook-form';
import { TextFieldInput } from '.';

type IProps = UseControllerProps & TextFieldProps;

export const ControlledInput = (props: IProps) => {

  const { field, fieldState } = useController(props);

  return (
    <TextFieldInput
      error={fieldState.invalid}
      helperText={fieldState.error && fieldState.error.message}
      {...field}
      {...props}
    />
  );
};